import type { KYCQuestionDefinition } from '@anchorage/graphql/generated';
import { KYCQuestionnaireElementLayoutTextAreaSize } from '@anchorage/graphql/generated';
import type { CustomLinkProps } from '@anchorage/utils';
import { parseSanitize } from '@anchorage/utils';
import { FormTextArea, reactHookForm } from '@latitude/form';
import type { ComponentType } from 'react';
import { useMemo } from 'react';

type Props = {
  question: KYCQuestionDefinition;
  isDisabled?: boolean;
  textAreaSize?: KYCQuestionnaireElementLayoutTextAreaSize | null;
  CustomLink?: ComponentType<CustomLinkProps>;
  trackFn?: (questionId: string) => void;
};

function TextareaComponent({
  question,
  isDisabled = false,
  textAreaSize,
  CustomLink,
  trackFn = () => {},
}: Props) {
  const { control } = reactHookForm.useFormContext();

  const textAreaRows = useMemo(() => {
    if (textAreaSize === KYCQuestionnaireElementLayoutTextAreaSize.LARGE) {
      return 40;
    } else if (
      textAreaSize === KYCQuestionnaireElementLayoutTextAreaSize.REGULAR
    ) {
      return 16;
    }
    return 4;
  }, [textAreaSize]);

  return (
    <FormTextArea
      message={parseSanitize(question?.footer, CustomLink) || ''}
      control={control}
      name={`${question.id}.freeformText`}
      readOnly={isDisabled}
      rawProps={{
        rows: textAreaRows,
        onChangeCapture: () => trackFn(question.id),
      }}
    />
  );
}

export { TextareaComponent };
